module.exports = require("@vespaiach/axios-fetch-adapter");